import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translate, isRTL, LANGUAGES } from "./translations";

const LangCtx = createContext({ lang: "no", setLang: () => {}, t: (k) => k });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try { return localStorage.getItem("nourozi_lang") || "no"; } catch { return "no"; }
  });

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = isRTL(lang) ? "rtl" : "ltr";
  }, [lang]);

  const setLang = useCallback((code) => {
    setLangState(code);
    try { localStorage.setItem("nourozi_lang", code); } catch { /* ignore */ }
  }, []);

  const t = useCallback((k) => translate(k, lang), [lang]);

  return <LangCtx.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>{children}</LangCtx.Provider>;
}

export function useLang() { return useContext(LangCtx); }
